<template>
  <OutsideClickWrapper @click="optionsVisible = false" @focus="handleOutsideFocus">
    <div
      class="custom-form-select"
      :class="{ disabled: disabled }"
      :style="optionsVisible && `z-index: 300`"
      @focus.capture="handleFocus"
    >
      <fieldset :class="{ focused: optionsVisible }">
        <label class="label" :class="{ 'text-muted': !valueString }">{{ label }}</label>
        <legend @click="onClicked">
          <div class="legend-body">
            <span class="placeholder" :class="{ 'visually-hidden': valueString }">{{ legend }}</span>
            <span v-if="valueString && !searchAble" aria-hidden="true" class="value">{{ valueString }}</span>
            <span class="select-icon"> <i class="fa-light fa-chevron-down"></i></span>
          </div>
        </legend>
        <div class="options" :class="{ 'visually-hidden': !optionsVisible }">
          <label
            v-for="(option, index) in options"
            :key="index"
            class="list-option"
            :class="{ 'has-supporting-content': optionHasImgSources || optionsHasMarkup }"
            @keyup.stop.enter="optionsVisible = false"
            @keyup.esc="optionsVisible = false"
            @click.stop="optionsVisible = false"
          >
            <div>
              <input
                v-if="multiSelect"
                v-model="localValue"
                :value="option.value || option"
                :type="optionsType"
                class="input"
              />
              <input v-else v-model="localValue" :value="option.value || option" type="radio" class="input" />
              <span v-if="i18n">{{ $t(option.name) }}</span>
              <span v-else>{{ option.name || option }}</span>
            </div>

            <div class="supporting-content">
              <span v-if="optionsHasMarkup" v-html="option.markup"></span>
              <span v-if="optionHasImgSources">
                <img :src="require(`@/assets/${option.imgSrc}`)" :alt="option.name + ' icon'" />
              </span>
            </div>
          </label>
        </div>
      </fieldset>
    </div>
  </OutsideClickWrapper>
</template>

<script>
import OutsideClickWrapper from "@/components/OutsideClickWrapper.vue";
export default {
  components: { OutsideClickWrapper },
  name: "CustomSelect",
  model: {
    event: "change"
  },
  props: {
    optionsType: {
      type: String,
      default: "checkbox"
    },
    legend: {
      type: String,
      default: "Select"
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String, Number],
      default: ""
    },
    label: {
      type: String
    },
    optionsHasMarkup: {
      type: Boolean
    },
    optionHasImgSources: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    searchAble: {
      type: Boolean,
      default: false
    },
    i18n: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      optionsVisible: false
    };
  },
  computed: {
    valueString() {
      return this.multiSelect ? this.value.join(", ") : this.value;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(data) {
        this.$emit("change", data);
      }
    },
    multiSelect() {
      return Array.isArray(this.value);
    }
  },
  methods: {
    handleFocus(e) {
      if (this.disabled) return;
      // Fix IE11 quirks.
      if (e.target.tagName === "DIV") return;
      this.optionsVisible = true;
    },
    onClicked() {
      if (this.disabled) return;
      this.optionsVisible = !this.optionsVisible;
    },
    handleOutsideFocus(e) {
      this.optionsVisible = false;
    },
    handleVisibility(e) {
      if (!this.multiSelect) this.optionsVisible = false;
    }
  }
};
</script>

<style lang="less">
.custom-form-select {
  margin-top: 6px;
  position: relative;
  height: 43px;
  width: 100%;
  fieldset {
    padding: 0;
  }
  legend {
    border: 1px solid #ccc;
    border-radius: 3px;
    position: relative;
    cursor: pointer;
    padding-left: 12px;
    margin-bottom: 2px;
  }
  .label {
    position: absolute;
    top: 0;
    font-size: 12px;
    padding: 0 4px;
    background: #fff;
    transform: translate(8px, -50%);
    font-weight: 500;
    z-index: 10;
  }

  .legend-body {
    // height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .placeholder,
  .value {
    padding: 10px 0;
    font-size: 14px;
    color: #8f979c;
    font-weight: 500;
  }
  .value {
    color: var(--charcoal);
  }
  .options {
    background: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }

  .list-option {
    display: block;
    padding: 8px 12px 8px 0;
    font-weight: 400;
    cursor: pointer;
    margin-bottom: 0;

    img {
      height: 12px;
    }

    &:hover {
      background: var(--charcoal-10);
    }
    &:focus-within {
      background: var(--charcoal-10);
    }

    &.has-supporting-content {
      display: flex;
      justify-content: space-between;
    }
  }

  input {
    opacity: 0;
  }

  input:checked + span {
    font-weight: 700;
  }

  .select-icon {
    position: absolute;
    font-size: 14px;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }

  .visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
